webpackJsonp([124476687985319],{

/***/ 446:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(3);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Connect = __webpack_require__(29);
	
	var _Connect2 = _interopRequireDefault(_Connect);
	
	var _Markdown = __webpack_require__(5);
	
	var _Markdown2 = _interopRequireDefault(_Markdown);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(
	    _Connect2.default,
	    null,
	    _react2.default.createElement(
	      'h1',
	      null,
	      'byId'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'This blueprint allows you to extract a model from the store by it\'s ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'id'
	      ),
	      ' attribute. If the model doesn\'t exist, the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'get'
	      ),
	      ' action will be invoked to retrieve it.'
	    ),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Usage'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Basic usage is below:'
	    ),
	    _react2.default.createElement(_Markdown2.default, { text: '\n      import { connect } from \'lore-hook-connect\';\n\n      connect((getState, props) => {\n        return {\n          tweet: getState(\'tweet.byId\', {\n            id: 1,\n            query: {\n              _embed: \'user\'\n            }\n          })\n        }\n      })\n      ' }),
	    _react2.default.createElement(
	      'p',
	      null,
	      'There are two attributes you can provide in the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'params'
	      ),
	      ' object.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'The first attribute is ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'id'
	      ),
	      ', which is required, and is the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'id'
	      ),
	      ' (or primary key) of the resource you want to retrieve. It can be a ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'string'
	      ),
	      ' or a ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'number'
	      ),
	      '.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'The second attribute is ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'query'
	      ),
	      ', which is an object of query parameters you want sent to the API.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'The example about would become the API call ',
	      _react2.default.createElement(
	        'code',
	        null,
	        '/tweets/1?_embed=user'
	      ),
	      ', which, if you\'re using',
	      _react2.default.createElement(
	        'code',
	        null,
	        'json-server'
	      ),
	      ', would nest the user resource inside the tweet.'
	    ),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Blueprint'
	    ),
	    _react2.default.createElement(_Markdown2.default, { text: '\n      export default {\n\n        defaults: {\n          id: null\n        },\n\n        verifyParams: function(params) {\n          if (!params.id) {\n            throw new InvalidGetStateCall(this.reducerKey);\n          }\n        },\n\n        getPayload: function(reducerState, params) {\n          const key = params.id;\n          return reducerState[key];\n        },\n\n        callAction: function(action, params) {\n          const id = params.id;\n          const query = params.query;\n          return action(id, query).payload;\n        }\n\n      };\n      ' })
	  );
	};
	
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-connect-by-id-js-1a3016169e73c3c15eac.js